module.exports = __webpack_public_path__ + "assets/images/marker-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/marker-icon.png
// module id = 1517
// module chunks = 1